import type {LogName} from "./types/logname.js";
import {AppType, appType} from "../helper/appInfo.js";

export function log(message: string, logName: LogName) {
    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.errorLogging?.(logName, message);
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.errorLogging?.postMessage(
            {
                logName: logName,
                message: message
            }
        );
    }
}